import { formatDate } from 'ClientService';

export const LagRatingResponseDate = ({ value, record }) =>
  record.result?.lagRatingResponseDate ? formatDate(record.result.lagRatingResponseDate) : ''
